import CreatorRevenuePage from "./CreatorRevenuePage";

export default CreatorRevenuePage;
